<!-- =========================================================================================
    File Name: ChatLog.vue
    Description: Chat Application - Log of chat
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<!-- hasSentPreviousMsg -->
<template>
  <div id="visualizer">
    <!-- <pre>{{artefact}}</pre> -->
    <vx-card v-if="false && artefact && artefact.res && !(artefact.res.index || artefact.res.demand || artefact.res.order || artefact.res.trend) && artefact.res.error">
      <h2>Note</h2>

      <vs-alert color="danger" icon="new_releases" active="true" class="mt-5">
        <p>{{artefact.res.error}}</p>
      </vs-alert>
    </vx-card>
    <!-- <vx-card
      v-if="artefact && artefact.res && (artefact.res.index || artefact.res.demand || artefact.res.order || artefact.res.trend) && !artefact.res.error"
      :title="artefact.query"
      subtitle="Visualize the demand trend and forecast for the selected channels and categories"
    >
      <div class="flex justify-between items-end flex-grow">
        <div class="flex flex-wrap items-center md:justify-between">
          <div class="flex flex-wrap">
            <vs-chip :color="index === 0 ? 'primary' : ''" v-for="(tag, index) in artefact.tags" :key="index">
              <vs-avatar :text="tag.type" />
              {{ tag.tag }}
            </vs-chip>
          </div>
        </div>
      </div>
      <vs-alert color="primary" icon="new_releases" active="true" class="mt-5" v-if="artefact.note">
        <p>{{artefact.note}}</p>
      </vs-alert>
    </vx-card> -->
    <div
      v-if="artefact && artefact.res && (artefact.res.index || artefact.res.demand || artefact.res.order || artefact.res.trend) && !artefact.res.error"
    >
      <div v-if="['SPO'].includes(artefact.type)">
        <vs-tabs>
          <!-- <vs-tab label="Trend" icon-pack="feather" icon="icon-home">
            <trend :artefact="artefact" :key="artefact.type+'-1'" type="trend"></trend>
          </vs-tab> -->
          <vs-tab label="Order" icon-pack="feather" icon="icon-box">
            <order :artefact="artefact" :key="artefact.type+'-2'"></order>
          </vs-tab>
        </vs-tabs>
      </div>
      <div v-if="['SDF'].includes(artefact.type)">
        <vs-switch color="success" v-model="switchMock" class="mb-base">
          <span slot="on">Demo</span>
          <span slot="off">Actual</span>
        </vs-switch>
        <!-- <brush-chart/> -->
        <div v-if="!switchMock">
          <dem-for-trend :artefact="artefact" :key="artefact.type+'-1'" type="category"></dem-for-trend>
          <item-list :artefact="artefact" :key="artefact.type+'-2'" type="category"></item-list>
        </div>
        <div v-if="switchMock">
          <dem-for-trend-mock :artefact="artefact" :key="artefact.type+'-1'" type="category"></dem-for-trend-mock>
          <item-list-mock :artefact="artefact" :key="artefact.type+'-2'" type="category"></item-list-mock>
        </div>
        <!-- <trend :artefact="artefact" :key="artefact.type+'-1'" type="category"></trend> -->
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Trend from "./Trend.vue";
import Order from "./Order.vue";
import ItemList from "./ItemList.vue";
import ItemListMock from "./ItemListMock.vue";
import DemForTrend from "./DemForTrend.vue";
import DemForTrendMock from "./DemForTrendMock.vue";
import BrushChart from './BrushChart.vue'

export default {
  props: {
    artefact: { type: Object, required: true }
  },
  data() {
    return {
      switchMock: false
    };
  },
  watch: {},
  computed: {},
  methods: {
  },
  mounted() {
  },
  components: {
    Trend,
    Order,
    ItemList,
    ItemListMock,
    DemForTrend,
    DemForTrendMock,
    BrushChart
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/pages/profile.scss";
#visualizer {
  .tagger {
    padding: 0.5rem 1rem;
    border-radius: 25px;
    margin-right: 1rem;
    margin-bottom: 1.5rem;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
  .tasks-today-container {
    .tasks-today__task {
      transition: background 0.15s ease-out;
      .tasks-today__actions {
        display: none;
      }

      &:hover {
        background: rgba(var(--vs-primary), 0.04);
        .tasks-today__actions {
          display: flex;
        }
      }
    }
  }

  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
</style>
